export const HistoryLabelsConstants = {
    policyTransactions: 'Policy Transactions',
    backoutConfirmation: 'Are you sure you want to back out this transaction?',
    backoutComplete: 'Back out has been completed.'
};
